/** Ждём появления <video id="..."> в DOM (после CONNECTING / mount слота). */
export const waitForVideoElement = (videoElementId, maxMs = 10_000) =>
  new Promise((resolve, reject) => {
    const started = performance.now();

    const tick = () => {
      const el = document.getElementById(videoElementId);
      if (el instanceof HTMLVideoElement) {
        resolve(el);
        return;
      }
      if (performance.now() - started > maxMs) {
        reject(
          new Error(
            `Anam: video #${videoElementId} not found (mount AnamAvatarVideo before stream)`,
          ),
        );
        return;
      }
      requestAnimationFrame(tick);
    };

    tick();
  });
